import gql from "graphql-tag";
import { ReturnMessage } from "../types/ReturnMessage";

export const REGISTER_COACH_MUTATION = gql`
  mutation RegisterCoach(
    $uuid: String!
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $locale: String!
    $phone: String!
    $country: String
    $countryCode: String!
    $bio: [CoachBioInput!]!
    $timeZone: String!
    $title: String
    $consultationUrl: String
    $cnConsultationUrl: String
    $avatarFilename: String
  ) {
    registerCoach(
      uuid: $uuid
      email: $email
      password: $password
      locale: $locale
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      country: $country
      countryCode: $countryCode
      bio: $bio
      timeZone: $timeZone
      title: $title
      consultationUrl: $consultationUrl
      cnConsultationUrl: $cnConsultationUrl
      avatarFilename: $avatarFilename
    ) {
      returnMessage {
        status
        message
      }
    }
  }
`;

export interface RegisterCoachData {
  registerCoach: {
    returnMessage: ReturnMessage;
  };
}

export interface RegisterCoachVariables {
  uuid: string;
  email: string;
  password: string;
  locale: string;
  role: string;
  firstName: string;
  lastName: string;
  phone: string;
  country?: string;
  countryCode: string;
  bio: Array<Object>;
  timeZone: string;
  title?: string;
  consultationUrl?: string;
  cnConsultationUrl?: string;
  avatarFilename?: string;
}
